import React from 'react';

const SuccessMessage = ({ onReset }) => {
  return (
    <div className="text-center py-12">
      <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100 mb-4">
        <svg className="h-6 w-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
        </svg>
      </div>
      <h3 className="text-lg font-medium text-gray-900 mb-2">
        Vielen Dank!
      </h3>
      <p className="text-gray-600 mb-6">
        Ihre Angaben wurden erfolgreich übermittelt und werden zeitnah übernommen.
      </p>
      <button
        onClick={onReset}
        className="bg-blue-600 text-white py-2 px-4 rounded-lg font-medium hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors"
      >
        Neue Eingabe
      </button>
    </div>
  );
};

export default SuccessMessage;